export class SubmissionView {
  Id?: number;
  FacilityNumber?: string;
  OrderNumber?: string;
  SerialNumber?: string;
  RetailerName?: string;
  SoldDate?: Date;
  CustomerName?: string;
  Version?: string;
  Status?: string;
  FurnaceType?: string;
  CertificateMailed?: boolean;
  SubmissionCreateDate?: Date;
  HeatPumpInvoiceAvailable?: boolean;

  constructor(sub: any) {
    this.Id = sub.Id;
    this.FacilityNumber = sub.FacilityNumber;
    this.OrderNumber = sub.OrderNumber;
    this.SerialNumber = sub.SerialNumber;
    this.CertificateMailed = sub.CertificateMailed;
    this.CustomerName = sub.CustomerName;
    this.SoldDate = sub.SoldDate;
    this.Status = sub.Status;
    this.FurnaceType = sub.FurnaceType;
    this.Version = sub.Version;
    this.RetailerName = sub.RetailerName;
    this.SubmissionCreateDate = sub.SubmissionCreateDate;
    this.HeatPumpInvoiceAvailable = sub.HeatPumpInvoiceAvailable;
  }
}
